import { html, css, unsafeCSS } from 'lit';
import SotbitButton from '../button';
import styles from './button-dropdown.scss?inline';

export default class SotbitButtonDropdown extends SotbitButton {
    static styles = [
        SotbitButton.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = SotbitButton.properties;

    templateInnerContent() {
        return html` <slot name="icon-left"></slot>
            <slot name="content">${this.value}</slot>
            <slot name="icon-right">
                <sotbit-icon icon="dropdown" size="m" no-padding></sotbit-icon>
            </slot>`;
    }
}
